import DomComponent from '../lib/domComponent';
import {each} from '../lib/dom';

export default class AccordionComponent extends DomComponent {
    static selector = '[data-js-accordion]';
    el;

    constructor(el) {
        if(!el) {
            return false
        }

        super(el);

        this.toggles = this.el.querySelectorAll('[data-accordion-toggle]');

        each(this.toggles, (toggle) => {
            const content = toggle.nextElementSibling;

            if (content) {
                content.style.height = '0px';
                setTimeout(() => {
                    content.style.height = '';
                    content.dataset.maxHeight = `${content.offsetHeight}px`;
                    content.style.height = '0px';
                }, 1000);

                toggle.addEventListener('click', () => {
                    if (toggle.parentElement.classList.contains('active')) {
                        toggle.parentElement.classList.remove('active');
                        content.style.height = '0px';
                    } else {
                        toggle.parentElement.classList.add('active');
                        content.style.height = content.dataset.maxHeight;
                    }
                })
            } else {
                console.error('accordion has no content!', this.el)
            }
        })

        setTimeout(() => {
            this.loaded();
        })

    }
}